export default __webpack_public_path__ + "static/media/TT-Banner-for-dashboard.3964b0ef.jpg";